import { IRootState } from '../types/IRootState';
import { User } from '@/services/loginService';
import { LOGGED_IN } from '@/store/types/MutationTypes';
import { LOGGED_OUT } from '@/store/types/MutationTypes';
import { KM_LOGIN } from '@/store/types/MutationTypes';

export default {
  [LOGGED_IN](state: IRootState, user: User) {
    state.auth = {
      ...state.auth,
      token: user.accessToken,
      isLogged: true,
      user,
    };
  },
  [LOGGED_OUT](state: IRootState) {
    state.auth = {
      ...state.auth,
      token: null,
      isLogged: false,
      user: null,
    };
  },
};
